const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.context = this.dataset.context;
    this.accordion = this.querySelector("[data-accordion-item]");
    this.dropdown = this.querySelector("[data-dropdown]");
    this.localizationSelector = this.querySelectorAll("[data-value]");
    this.country_code = this.querySelector("[data-country-code]");
    this.language_code = this.querySelector("[data-language-code]");
  }

  connectedCallback() {
    if (this.context === "desktop") {
      document.addEventListener("menu:open", (e) => {
        if (e.target.classList.contains("localization-menu")) {
          this.dropdown.style.width = `${document.querySelector(".header").getBoundingClientRect().right - this.dropdown.getBoundingClientRect().left}px`;
        }
      });
    }

    this.localizationSelector.forEach((selector) => {
      selector.addEventListener("click", () => {
        this.language_code.value = selector.dataset.langValue;
        this.country_code.value = selector.dataset.value;
        this.form.submit();
      });
    });
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}
